import { H1, H3 } from "@blueprintjs/core";
import { css } from "glamor";
import * as React from "react";

const styles = {
	container: css({ widht: "100%" }),
	subtitle: css({ marginTop: "10px !important" }),
};

interface Props {
	dark: boolean;
}

const Privacy: React.FC<Props> = ({ dark: boolean }) => {
	return (
		<div {...styles.container}>
			<H1>Privacy Policy</H1>
			We are committed to ensuring that your privacy is protected and we shall endeavour to use any
			information that you provide when using this website in accordance with this privacy policy.
			This privacy policy explains what information we collect, how we protect any information you
			submit to us, and how we use it. We may amend this policy from time to time by updating this
			page. Therefore, we suggest you check this page occasionally to ensure you are aware of and
			are happy with any amendments.
			<H3 {...styles.subtitle}>What information do we collect?</H3>
			Personalinformation may be collected from you in various ways, for example: - 1. Information
			about your computer and about your visits to and use of this website (these are information
			about your browser, your IP address, your general location as determined from your IP address
			and provided by your browser, the site from which you come, and the links followed when
			leaving our site). This information is also collected through cookies. Your information will
			not be disclosed to any third party unless you have given your consent to such disclosure. We
			may disclose aggregate statistics about our site visitors in order to describe our services to
			prospective partners, advertisers and other reputable third parties and for other lawful
			purposes, but these statistics will include no personally identifying information.
			<H3 {...styles.subtitle}>Cookies</H3>
			Cookies Cookies are text files stored on your computer, and accessible only to the websites
			which create them. Our website may from time to time use cookies and log files for statistical
			analysis, to understand user behaviour, to administer the site, to tailor the information
			presented to a user based on their preferences, and to improve user experience. Any
			information gathered by our use of cookies is compiled on an aggregate, anonymous basis. Most
			web browsers automatically accept cookies, however you may delete, or disable cookies by
			following the instructions at http://www.allaboutcookies.org/manage-cookies/. Please note that
			you may not be able to take full advantage of a website if you disable cookies. Our website
			uses cookies to keep you logged in, so disabling cookies may impair your experience of the
			service. Further information about cookies can be found on the Interactive Advertising
			Bureau’s website www.allaboutcookies.org.
			<H3 {...styles.subtitle}>Google Analytics</H3>
			Our website uses Google Analytics, a web analytics service provided by Google, Inc.
			("Google"). The information generated by the cookie about your use of our website (including
			your IP address) will be transmitted to and stored by Google on servers in the United States.
			Google will use this information for the purpose of evaluating your use of our website,
			compiling reports on website activity for website operators and providing other services
			relating to website activity and internet usage. Google may also transfer this information to
			third parties where required to do so by law, or where such third parties process the
			information on Google’s behalf. Google will not associate your IP address with any other data
			held by Google. Further information about Google’s privacy policy may be obtained from
			http://www.google.com/privacy.html.
			<br />
			If you wish to opt out of our usage of Google Analytics, please contact us for instructions.
			<H3 {...styles.subtitle}>Changes</H3>
			We may make changes to this privacy policy from time to time. If we change our privacy policy
			we will post the changes on this page. If the change in our privacy policy affects the use of
			your personal information we will use our best endeavours to contact you by email to seek your
			consent to the use. Continued use of the service will signify that you agree to any such
			changes Your acceptance of this privacy policy If you do not agree to this privacy policy,
			please do not use our site. By using our site, you consent to the collection and use of
			information by us. Owing to the global nature of the internet infrastructure, the information
			you provide may be transferred in transit to countries outside the European Economic Area that
			do not have similar protections in place regarding your data and its use as set out in this
			policy. However, we have taken the steps outlined above to try to improve the security of your
			information. By submitting your information you consent to these transfers.
			<H3 {...styles.subtitle}>How to contact us</H3>
			We welcome your views about our website and our privacy policy. If you would like to contact
			us with any queries or comments please send an e-mail to marc.bitterli@synt.ch. You may
			request details of personal information. If you would like a copy of the information held on
			you or if you have any questions relating to this Privacy Policy or how we use the personal
			information we have about you, please write to: marc.bitteli@synt.ch.
		</div>
	);
};

export default Privacy;



// WEBPACK FOOTER //
// ./src/Public/Privacy.tsx